import { useIntl } from "react-intl";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const InboxList = ({ messageList }) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dashboardState = useSelector(
    ({ dashboard }) => dashboard,
    shallowEqual,
  );

  const inboxList =
    messageList ?? dashboardState.dashboard?.mbDashboardInboxists;

  return (
    <div className="d-flex flex-column gap-2">
      {inboxList?.map((mbDashboardInbox) => (
        <div
          key={mbDashboardInbox.inboxid}
          className="card bg-dark shadow text-white"
          style={{ cursor: "pointer" }}
          onClick={() => navigate(mbDashboardInbox.inboxid)}
        >
          <div className="card-body px-2 py-1">
            <div className="mb-1 position-relative">
              <div>{mbDashboardInbox.title}</div>
              {mbDashboardInbox.unread === "true" && (
                <div
                  className="rounded-circle bg-warning position-absolute"
                  style={{
                    width: "5px",
                    height: "5px",
                    top: "2px",
                    right: "0px",
                  }}
                />
              )}
            </div>
            {mbDashboardInbox.imageurl !== "" && (
              <div className="mb-1">
                <img alt="" src={mbDashboardInbox.imageurl} className="w-100" />
              </div>
            )}
            <div
              className="text-end"
              style={{ color: "gray", fontSize: "11px" }}
            >
              {mbDashboardInbox.totalcomment}{" "}
              {intl.formatMessage({ id: "comment" })}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
